import React from "react";
import { Link } from "react-router-dom";

import "./DashboardSidebar.scss";

import BrandLogo from "../../img/brand-logo-primary.png";
import BrandLogoIcon from "../../img/logo-icon.svg";
import CloseIcon from '../../img/close-icon.svg';

function DashboardSidebar(props) {
  return (
    <div
      className={
        props.SidebarAddClass
          ? "Dashboard_Sidebar Dashboard_Sidebar_strech"
          : "Dashboard_Sidebar"
      }
    >
      <div className="sidebar_close_icon" onClick={props.SidebarStrech}>
        <img className="close_icon" src={CloseIcon} alt="img" />
      </div>
      <div className="Dashboard_Sidebar_inr">
        <Link to="/" className="logo_otr">
          <img className="logo_icon" src={BrandLogoIcon} alt="logo" />
          <img className="brand_logo" src={BrandLogo} alt="logo" />
        </Link>
        <div className="sidebar_menu_main">
          <ul className="sidebar_menu_ul">
            <li className="sidebar_menu_li">
              <Link to="/" className="sidebar_menu_link">
                <i className="ri-dashboard-line menu_icon"></i>
                <p className="menu_text heading-m">Dashboard</p>
              </Link>
            </li>
            <li className="sidebar_menu_li">
              <Link to="/aktivitet-side" className="sidebar_menu_link">
                <i className="ri-archive-line menu_icon"></i>
                <p className="menu_text heading-m">Aktiviteter</p>
              </Link>
            </li>
            <li className="sidebar_menu_li">
              <Link to="/partner-dashbordet" className="sidebar_menu_link">
                <i className="ri-service-line menu_icon"></i>
                <p className="menu_text heading-m">Partnere</p>
              </Link>
            </li>

            {/* Todo: taking away this button for now, but might come back soon */}
            {/* <li className="sidebar_menu_li">
              <Link to="/analytics" className="sidebar_menu_link">
                <i class="ri-service-fill menu_icon"></i>
                <p className="menu_text heading-m">Analytics</p>
              </Link>
            </li> */}
            {/* <li className="sidebar_menu_li">
              <Link to="/order" className="sidebar_menu_link">
                <i class="ri-shopping-cart-fill menu_icon"></i>
                <p className="menu_text heading-m">Order</p>
              </Link>
            </li> */}
          </ul>
        </div>
      </div>
    </div>
  );
}

export default DashboardSidebar;
